import { v4 as uuidv4 } from 'uuid';

import {
	Container,
	Service,
	TrackingEventNames,
	TrackingService,
} from '../../../../symphony';

import { codeBitsFilerTrackingType } from '../../global-constants';
import { ITrackActionData } from '../../global-interface';
import { isNode } from '../../../../shared/public/utilsPublic/utilsPublic';
import { CodeBitsSearchFilter } from '../../../../api/public/code-api';

@Service()
export class SlTrackingService {
	private trackingService = Container.take('global', TrackingService);

	public onCodeBitsPageMount = (): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.userCodeBitsImpression,
			eventParams: {
				pageAlias: 'USER CODE BITS',
				id: isNode() ? null : uuidv4(),
			},
		});
	};

	public onProjectClick = ({ codeId, source }: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.userCodeBitsPostClick,
			eventParams: {
				pageAlias: 'USER CODE BITS',
				codeId,
				source,
				id: uuidv4(),
			},
		});
	};

	public onSearchClick = ({ searchText }: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.userCodeBitsSearchClick,
			eventParams: {
				pageAlias: 'USER CODE BITS',
				searchText,
				id: uuidv4(),
			},
		});
	};

	public onCTAClick = ({ ctaType }: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.userCodeBitsCTAClick,
			eventParams: {
				pageAlias: 'USER CODE BITS',
				ctaType,
				id: uuidv4(),
			},
		});
	};

	public onPaginationClick = ({
		paginationCtaType,
		pageNumber,
		clickPageNumber,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.userCodeBitsPaginationClick,
			eventParams: {
				pageAlias: 'USER CODE BITS',
				ctaType: paginationCtaType,
				pageNumber,
				clickPageNumber,
				id: uuidv4(),
			},
		});
	};

	public orderFilterChange = ({
		sectionName,
		languageName,
	}: ITrackActionData): void => {
		this.trackingService.tracking$.next({
			eventName: TrackingEventNames.userCodeBitsSectionClick,
			eventParams: {
				id: uuidv4(),
				pageAlias: 'USER CODE BITS',
				sectionName:
                    codeBitsFilerTrackingType[sectionName]
                    || codeBitsFilerTrackingType[CodeBitsSearchFilter[5]],
				languageName,
			},
		});
	};
}
